import { Button } from '@mui/material';
import { StyleObj } from '../../@types';
import { useMarketplaceConfig } from '../../queries/marketplace';
import { MARKETPLACE_AUTH_MODEL } from '../../types/enums';
import { useModal } from '../../hooks/useDialog';
import { SkinnedBalanceModal } from '../../config/skinRegistry/components';
import useLocalization from '../../hooks/useLocalization';
import { getWalletModalProps } from '../../config/walletModal';
import { mergeSx } from '../../utils/styles';

type ColorType = 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';

export type DepositButtonProps = {
  onClick?: () => void;
  title?: string;
  color?: ColorType;
} & React.ComponentProps<typeof Button>;

const styles: StyleObj = {
  button: {
    borderRadius: 1,
    height: 32,
    '&:disabled': {
      backgroundColor: 'neutral.400',
      color: 'neutral.200',
    },
  },
};

const DepositButton = ({ onClick, title, color, children, sx, ...rest }: DepositButtonProps) => {
  const { openModal, closeModal } = useModal();
  const { data: marketplaceConfig } = useMarketplaceConfig();
  const { t } = useLocalization();

  const shouldShowDepositButton =
    marketplaceConfig?.marketplaceConfig?.model === MARKETPLACE_AUTH_MODEL.USER_REGISTRATION;

  const handleClick = () => {
    onClick?.();
    openModal(<SkinnedBalanceModal handleClose={closeModal} showBalanceContact={false} />, getWalletModalProps());
  };

  if (!shouldShowDepositButton) {
    return null;
  }

  return (
    <Button color={color ?? 'info'} onClick={handleClick} size='small' sx={mergeSx(styles.button, sx)} {...rest}>
      {children ?? title ?? t('wallet')}
    </Button>
  );
};

export default DepositButton;
